import camelCase from 'lodash-es/camelCase'
import forOwn from 'lodash-es/forOwn'
import isArray from 'lodash-es/isArray'
import isFunction from 'lodash-es/isFunction'
import isObject from 'lodash-es/isObject'
import isPlainObject from 'lodash-es/isPlainObject'

/* tslint:disable no-any */
const toCamelCase = (obj: any): any => {
  if (isPlainObject(obj) || isArray(obj)) {
    const mappedObject = isArray(obj) ? [] : {}

    forOwn(obj, (val, key) => {
      if (isArray(obj)) {
        (mappedObject as any[]).push(toCamelCase(val))
      } else {
        mappedObject[camelCase(key)] = isArray(val) ? toCamelCase(val) : val
      }
    })

    return mappedObject
  } else {
    return obj
  }
}
export const toCamelCaseMiddleware: any = (store: any): any => (next: any): any => (action: any): any => {
  if (!isFunction(action) && !!action.type && action.type[0] !== '@' && isObject(action.payload)) {
    action.payload = toCamelCase(action.payload)
  }
  return next(action)
}
/* tslint:enable no-any */

export default toCamelCaseMiddleware



// WEBPACK FOOTER //
// ./src/store/fixApiCasing.ts